<template>
  <v-app>
    <v-content>
      <header-component />
      <Drawler/>
      <Navbar/>
      <user-account/>
      <v-container>
        <router-view/>
      </v-container>
      <main-footer/>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from './components/partials/navbar'
import userAccount from './components/partials/AuthForm/userAccount'
import Drawler from './components/partials/drawler'
import mainFooter from './components/partials/mainFooter'
import HeaderComponent from './components/partials/header'

export default {
  name: 'App',
  components: {
    Drawler,
    Navbar,
    userAccount,
    mainFooter,
    HeaderComponent
  }
}
</script>

<style lang="scss">
  @import "./assets/styles";
</style>



// WEBPACK FOOTER //
// src/App.vue